import React, { useState, useEffect } from 'react'
import ApiService from '../../utils/ApiService';
import { Box, Typography, Grid, Switch, IconButton, Drawer, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SpeakerIcon from '@mui/icons-material/Speaker';
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CakeIcon from '@mui/icons-material/Cake';
import PeopleAltIcon from '@mui/icons-material/People';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ChatBubbleIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/Group';
import WorkIcon from '@mui/icons-material/Work';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AssignmentTurnedInIcon from '@mui/icons-material/Settings';
import { notificatioSettingSkeleton } from '../../utils/SkeletonHelper'

const notificationDrawer = [
    { title: 'Email' },
    { title: 'Application' },
    { title: 'Push Notification' },
];


const notificationIcons = [
    { icon: <ModeCommentIcon /> },
    { icon: <CelebrationIcon /> },
    { icon: <CakeIcon /> },
    { icon: <WorkIcon /> },
    { icon: <PeopleAltIcon /> },
    { icon: <EmojiEventsIcon /> },
    { icon: <WorkIcon /> },
    { icon: <CelebrationIcon /> },
    { icon: <CalendarMonthIcon /> },
    { icon: <SpeakerIcon /> },
];

const NotificationPage = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('');
    const [mainSwitchStates, setMainSwitchStates] = useState({});
    const [drawerSwitchStates, setDrawerSwitchStates] = useState({});
    const [notificationSettings, setNotificationSettings] = useState([]);

    useEffect(() => {
        ApiService.get('notificationSettings')
            .then(response => {
                console.debug("notificationSettings", response.data.data);
                const apiData = response.data.data;

                if (apiData) {
                    setNotificationSettings(apiData);
                    initializeSwitchStates(apiData);
                }
            })
            .catch(error => {
                console.error("API request error:", error);
            });
    }, []);

    const initializeSwitchStates = (settings) => {
        const mainSwitches = {};
        const drawerSwitches = {};

        settings.forEach(setting => {
            mainSwitches[setting.notificationName] = setting.userNotificationStatus === "1";
            drawerSwitches[setting.notificationName] = {};
            notificationDrawer.forEach(drawer => {
                drawerSwitches[setting.notificationName][drawer.title] = setting.userNotificationStatus === "1";
            });
        });

        setMainSwitchStates(mainSwitches);
        setDrawerSwitchStates(drawerSwitches);
    };

    const handleOpenDrawer = (title) => {
        setCurrentTitle(title);
        if (!drawerSwitchStates[title]) {
            setDrawerSwitchStates((prevState) => ({
                ...prevState,
                [title]: notificationDrawer.reduce((acc, drawer) => {
                    acc[drawer.title] = false;
                    return acc;
                }, {})
            }));
        }
        setDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setDrawerOpen(false);
        setCurrentTitle('');
    };

    const handleMainSwitchChange = (title) => (event) => {
        const newState = event.target.checked;
        setMainSwitchStates((prevState) => ({
            ...prevState,
            [title]: newState,
        }));
    };

    const handleDrawerSwitchChange = (drawerTitle) => (event) => {
        setDrawerSwitchStates((prevState) => ({
            ...prevState,
            [currentTitle]: {
                ...prevState[currentTitle],
                [drawerTitle]: event.target.checked,
            }
        }));
        const anyDrawerSwitchOn = Object.values(drawerSwitchStates[currentTitle] || {}).some(switchState => switchState);
        setMainSwitchStates((prevState) => ({
            ...prevState,
            [currentTitle]: anyDrawerSwitchOn,
        }));
    };

    const handleSave = () => {
        const trueMainSwitches = Object.keys(mainSwitchStates).filter(key => mainSwitchStates[key]);
        const trueDrawerSwitches = Object.keys(drawerSwitchStates[currentTitle] || {}).filter(key => drawerSwitchStates[currentTitle][key]);

        console.log("a1", trueMainSwitches);
        console.log(`a1`, trueDrawerSwitches, currentTitle);

        handleCloseDrawer();
    };

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    return (
        <Box>
            <Box sx={{ my: 2 }}>
                <Typography variant="h5">Notification Configuration</Typography>
                <Typography variant="subtitle2">
                    Configure the notification of My connect screens and tasks by customizing it.
                </Typography>
            </Box>
            <Box
                className="settingTable"
                sx={{
                    height: 'calc(100vh - 64px - 64px)',
                    overflow: 'hidden',
                    '&:hover': {
                        overflow: 'auto',
                    },
                    '&:hover::-webkit-scrollbar': {
                        width: '4px',
                    },
                }}
            >
                {notificationSettings.length ? notificationSettings.map((setting, index) => (
                    <Box sx={{ my: 2 }} key={index}>
                        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs={8}>
                                <Box sx={{ display: 'flex' }}>
                                    <Box sx={{ mt: 0.5 }}>
                                        {notificationIcons[index].icon}
                                    </Box>

                                    <Box sx={{ ml: 1 }}>
                                        <Typography variant="body1">{setting.notificationName}</Typography>
                                        <Typography variant="caption">{setting.notificationDescription}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton aria-label="Settings" onClick={() => handleOpenDrawer(setting.notificationName)}>
                                        <SettingsIcon />
                                    </IconButton>
                                    <Switch checked={mainSwitchStates[setting.notificationName]} onChange={handleMainSwitchChange(setting.notificationName)} {...label} />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                )) : notificatioSettingSkeleton()}
            </Box>
            <Drawer anchor="right" open={drawerOpen}>
                <Box sx={{ width: '30rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ backgroundColor: '#DBEAFE' }}>
                        <Box sx={{ mx: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={8}>
                                    <Box sx={{ marginTop: '0.5rem' }}>
                                        <Typography variant="body1" fontWeight="bold">{currentTitle} Notification Settings</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Box>
                                        <IconButton aria-label="delete" onClick={handleCloseDrawer}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    <Box sx={{ mx: 2, my: 2, flexGrow: 1 }}>
                        <Box>
                            <Typography variant="subtitle2">Notification Message Window</Typography>
                            <Typography variant="caption">
                                Choose the window you want to send onboarding details notification on
                            </Typography>
                        </Box>
                        <Box sx={{ my: 2 }}>
                            {notificationDrawer.map((drawer, index) => (
                                <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Box><Typography variant="body1">{drawer.title}</Typography></Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Switch checked={drawerSwitchStates[currentTitle]?.[drawer.title] || false} onChange={handleDrawerSwitchChange(drawer.title)} {...label} />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                    <Box sx={{ mx: 2, my: 2, display: 'flex' }}>
                        <Box><Button variant="contained" size='small' onClick={handleSave}>Save</Button></Box>
                        <Box sx={{ ml: 1 }}><Button variant="text" size='small' onClick={handleCloseDrawer}>Cancel</Button></Box>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    );
};
export default NotificationPage;
